import addDays from 'date-fns/addDays';

export default function(plusDays = 0) {
  return addDays(new Date(), plusDays);
}
